<template>
    <div class="homework">
        <section class="home-cards">
        <h4>HOME WORK POLICY</h4>
        <hr class="hr">
        <h6>Children are assigned homework every day of the week. Work in the following subjects is given.</h6>
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>Nursery Section:</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>
                    English Language
                    <ul>
                      <li>Phonics</li>
                      <li>Handwriting</li>
                    </ul>
                </li>
                  <li>Mathematics</li>
                  <li>Integrated Science</li>
                  <li>Social Studies</li>
                  <li>Creative and Technology Studies</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>Lower and Upper Primary Section:</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>
                    English Language
                    <ul>
                      <li>Phonics</li>
                      <li>Handwriting</li>
                      <li>Comprehension</li>
                    </ul>
                </li>
                  <li>Mathematics</li>
                  <li>Integrated Science</li>
                  <li>Social Studies</li>
                  <li>Creative and Technology Studies</li>
                </ol>
                </div>
                <div class="feature-text">
                <p>In addition to the above, pupils are also given holiday assignments that are carried out during school holiday periods.</p>
                </div>
                <div class="feature-detail">
                  <table>
                    <tr>
                        <th>DAY</th>
                        <th>SUBJECT</th>
                    </tr>
                    <tr>
                        <td>Monday</td>
                        <td>Mathematics/English Language</td>
                    </tr>
                    <tr>
                        <td>Tuesday</td>
                        <td>Social Studies/Integrated Science</td>
                    </tr>
                    <tr>
                        <td>Wednesday</td>
                        <td>Mathematics/English Language</td>
                    </tr>
                    <tr>
                        <td>Thursday</td>
                        <td>C.T.S/Chinyanja</td>
                    </tr>
                    <tr>
                        <td>Friday</td>
                        <td>Mathematics and any other subject</td>
                    </tr>
                    </table>
                <div class="feature-text">
                  <p>Parents are required to check and sign for the homework before pupils return their books for marking</p>
                </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Homework',
  components: { }
}
</script>

<style>
.homework .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.homework .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.homework .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 10px auto;
  background-color: var(--inspire-gold);
}
.homework .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.homework .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.homework .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.homework .feature p {
  color: var(--inspire-charcoal);
}
.homework .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.homework .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.homework .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
.homework .feature-text p {
  color: var(--inspire-rose);
  font-size: 15px;
}
.homework .feature .feature-detail table {
  width: 100%;
  border: 1px solid black;
}
.homework .feature .feature-detail table td {
  border: 1px solid black;
}
</style>
